export default __webpack_public_path__ + "static/media/pencil.08614029.svg";